import mockdata from '../utils/mock'

export const TestData = () => mockdata